// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UserManagement.module.scss */
.UserManagement_userManagement__LMTgO {
  padding: 20px;
}
.UserManagement_userManagement__LMTgO h1 {
  margin: 0;
}

.UserManagement_headerRow__FXW48 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.UserManagement_addButton__aY2Lj {
  padding: 8px 16px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
.UserManagement_addButton__aY2Lj:hover {
  background-color: #218838;
}

.UserManagement_filters__S0jnA {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.UserManagement_filterItem__K3\\+MJ {
  min-width: 280px;
  flex: 1 1;
}

.UserManagement_filterLabel__\\+B57u {
  font-size: 12px;
  margin-bottom: 6px;
  opacity: 0.8;
}

.UserManagement_tableWrap__HTd9X {
  width: 100%;
  overflow-x: auto;
}

.UserManagement_userTable__Xv8Qw {
  width: 100%;
  min-width: 720px;
  border-collapse: collapse;
}
.UserManagement_userTable__Xv8Qw th,
.UserManagement_userTable__Xv8Qw td {
  padding: 10px;
  border: 1px solid #ccc;
  text-align: left;
  vertical-align: top;
}
.UserManagement_userTable__Xv8Qw th {
  background-color: #f8f9fa;
}

.UserManagement_actions__W-gp6 {
  white-space: nowrap;
}
.UserManagement_actions__W-gp6 button {
  padding: 5px 10px;
  margin-right: 6px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
.UserManagement_actions__W-gp6 button:first-of-type {
  background-color: #ffc107;
  color: black;
}
.UserManagement_actions__W-gp6 button:first-of-type:hover {
  background-color: #e0a800;
}
.UserManagement_actions__W-gp6 button:last-of-type {
  background-color: #dc3545;
  color: white;
}
.UserManagement_actions__W-gp6 button:last-of-type:hover {
  background-color: #c82333;
}

/* Mobile cards (default hidden on desktop) */
.UserManagement_userCards__tEk9R {
  display: none;
}

/* Responsive */
@media (max-width: 768px) {
  .UserManagement_userManagement__LMTgO {
    padding: 12px;
  }
  .UserManagement_filterItem__K3\\+MJ {
    min-width: 100%;
  }
  .UserManagement_tableWrap__HTd9X {
    display: none;
  }
  .UserManagement_userCards__tEk9R {
    display: grid;
    gap: 12px;
  }
  .UserManagement_userCard__AJqQ0 {
    border: 1px solid #e5e5e5;
    border-radius: 10px;
    padding: 12px;
    background: #fff;
  }
  .UserManagement_cardRow__CNPMx {
    display: grid;
    grid-template-columns: 110px 1fr;
    gap: 8px;
    padding: 6px 0;
  }
  .UserManagement_cardLabel__5XS8S {
    font-size: 12px;
    opacity: 0.7;
  }
  .UserManagement_cardValue__nLXTc {
    word-break: break-word;
  }
  .UserManagement_cardActions__Qsb4F {
    display: flex;
    gap: 8px;
    margin-top: 10px;
  }
  .UserManagement_cardActions__Qsb4F button {
    flex: 1 1;
    padding: 10px 12px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
  }
  .UserManagement_cardActions__Qsb4F button:first-of-type {
    background-color: #ffc107;
  }
  .UserManagement_cardActions__Qsb4F button:last-of-type {
    background-color: #dc3545;
    color: white;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/UsersPage/UserManagement.module.scss"],"names":[],"mappings":"AAAA,+BAAA;AACA;EACE,aAAA;AACF;AACE;EACE,SAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAAF;;AAGA;EACE,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAAF;AAEE;EACE,yBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AADF;;AAIA;EACE,gBAAA;EACA,SAAA;AADF;;AAIA;EACE,eAAA;EACA,kBAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;EACA,gBAAA;AADF;;AAIA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;AADF;AAGE;;EAEE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AADJ;AAIE;EACE,yBAAA;AAFJ;;AAMA;EACE,mBAAA;AAHF;AAKE;EACE,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAHJ;AAKI;EACE,yBAAA;EACA,YAAA;AAHN;AAKM;EACE,yBAAA;AAHR;AAOI;EACE,yBAAA;EACA,YAAA;AALN;AAOM;EACE,yBAAA;AALR;;AAWA,6CAAA;AACA;EACE,aAAA;AARF;;AAWA,eAAA;AACA;EACE;IACE,aAAA;EARF;EAWA;IACE,eAAA;EATF;EAYA;IACE,aAAA;EAVF;EAaA;IACE,aAAA;IACA,SAAA;EAXF;EAcA;IACE,yBAAA;IACA,mBAAA;IACA,aAAA;IACA,gBAAA;EAZF;EAeA;IACE,aAAA;IACA,gCAAA;IACA,QAAA;IACA,cAAA;EAbF;EAgBA;IACE,eAAA;IACA,YAAA;EAdF;EAiBA;IACE,sBAAA;EAfF;EAkBA;IACE,aAAA;IACA,QAAA;IACA,gBAAA;EAhBF;EAkBE;IACE,SAAA;IACA,kBAAA;IACA,YAAA;IACA,kBAAA;IACA,eAAA;EAhBJ;EAkBI;IACE,yBAAA;EAhBN;EAmBI;IACE,yBAAA;IACA,YAAA;EAjBN;AACF","sourcesContent":["/* UserManagement.module.scss */\r\n.userManagement {\r\n  padding: 20px;\r\n\r\n  h1 {\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n.headerRow {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  margin-bottom: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.addButton {\r\n  padding: 8px 16px;\r\n  background-color: #28a745;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n\r\n  &:hover {\r\n    background-color: #218838;\r\n  }\r\n}\r\n\r\n.filters {\r\n  display: flex;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.filterItem {\r\n  min-width: 280px;\r\n  flex: 1;\r\n}\r\n\r\n.filterLabel {\r\n  font-size: 12px;\r\n  margin-bottom: 6px;\r\n  opacity: 0.8;\r\n}\r\n\r\n.tableWrap {\r\n  width: 100%;\r\n  overflow-x: auto;\r\n}\r\n\r\n.userTable {\r\n  width: 100%;\r\n  min-width: 720px;\r\n  border-collapse: collapse;\r\n\r\n  th,\r\n  td {\r\n    padding: 10px;\r\n    border: 1px solid #ccc;\r\n    text-align: left;\r\n    vertical-align: top;\r\n  }\r\n\r\n  th {\r\n    background-color: #f8f9fa;\r\n  }\r\n}\r\n\r\n.actions {\r\n  white-space: nowrap;\r\n\r\n  button {\r\n    padding: 5px 10px;\r\n    margin-right: 6px;\r\n    border: none;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n\r\n    &:first-of-type {\r\n      background-color: #ffc107;\r\n      color: black;\r\n\r\n      &:hover {\r\n        background-color: #e0a800;\r\n      }\r\n    }\r\n\r\n    &:last-of-type {\r\n      background-color: #dc3545;\r\n      color: white;\r\n\r\n      &:hover {\r\n        background-color: #c82333;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/* Mobile cards (default hidden on desktop) */\r\n.userCards {\r\n  display: none;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .userManagement {\r\n    padding: 12px;\r\n  }\r\n\r\n  .filterItem {\r\n    min-width: 100%;\r\n  }\r\n\r\n  .tableWrap {\r\n    display: none;\r\n  }\r\n\r\n  .userCards {\r\n    display: grid;\r\n    gap: 12px;\r\n  }\r\n\r\n  .userCard {\r\n    border: 1px solid #e5e5e5;\r\n    border-radius: 10px;\r\n    padding: 12px;\r\n    background: #fff;\r\n  }\r\n\r\n  .cardRow {\r\n    display: grid;\r\n    grid-template-columns: 110px 1fr;\r\n    gap: 8px;\r\n    padding: 6px 0;\r\n  }\r\n\r\n  .cardLabel {\r\n    font-size: 12px;\r\n    opacity: 0.7;\r\n  }\r\n\r\n  .cardValue {\r\n    word-break: break-word;\r\n  }\r\n\r\n  .cardActions {\r\n    display: flex;\r\n    gap: 8px;\r\n    margin-top: 10px;\r\n\r\n    button {\r\n      flex: 1;\r\n      padding: 10px 12px;\r\n      border: none;\r\n      border-radius: 8px;\r\n      cursor: pointer;\r\n\r\n      &:first-of-type {\r\n        background-color: #ffc107;\r\n      }\r\n\r\n      &:last-of-type {\r\n        background-color: #dc3545;\r\n        color: white;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userManagement": `UserManagement_userManagement__LMTgO`,
	"headerRow": `UserManagement_headerRow__FXW48`,
	"addButton": `UserManagement_addButton__aY2Lj`,
	"filters": `UserManagement_filters__S0jnA`,
	"filterItem": `UserManagement_filterItem__K3+MJ`,
	"filterLabel": `UserManagement_filterLabel__+B57u`,
	"tableWrap": `UserManagement_tableWrap__HTd9X`,
	"userTable": `UserManagement_userTable__Xv8Qw`,
	"actions": `UserManagement_actions__W-gp6`,
	"userCards": `UserManagement_userCards__tEk9R`,
	"userCard": `UserManagement_userCard__AJqQ0`,
	"cardRow": `UserManagement_cardRow__CNPMx`,
	"cardLabel": `UserManagement_cardLabel__5XS8S`,
	"cardValue": `UserManagement_cardValue__nLXTc`,
	"cardActions": `UserManagement_cardActions__Qsb4F`
};
export default ___CSS_LOADER_EXPORT___;
